import ExperienceCard from "../../components/experienceCard/experienceCard";
import "./timeline.css";

export default function Timeline({ experiences = [] }) {
    return (
        <div className="timeline">
            {experiences.map((experience, index) => (
            <ExperienceCard
                key={index}
                {...experience}
                side={index % 2 === 0 ? "left" : "right"}
            />
            ))}
        </div>
    );
}